import { render, staticRenderFns } from "./prontuario.vue?vue&type=template&id=b6931b20"
import script from "./prontuario.vue?vue&type=script&lang=js"
export * from "./prontuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports